<div class="skill-card" [class.skill-card--unfolded]="unfolded" (click)="toggleSkillUnfold()">
  <div class="skill-card__header">
    <h3 class="skill__title">{{ skill.name }}</h3>
  </div>

  <div class="skill-card__body">
    <div class="skill-card__body__left">
      <opac-progress-spinner [progress]="count$ | async" progressText="%">
        <span class="progress-tag">{{ count$ | async }}%</span>
      </opac-progress-spinner>
    </div>
    <div class="skill-card__body__right">
      <div class="skill-card__body__right__top">
        <div class="level__title">{{ skill.levelInProgress.name }}</div>
      </div>
      <div class="skill-card__body__right__bottom">
        <span class="level__progress"
          >{{ skill.resourcesCompleted }}/{{ skill.resourcesTotal }} {{ 'user.careerplans.lessons' | translate }}</span
        >
        <app-circle-arrow-button [enableToggle]="true" [unfolded]="unfolded"></app-circle-arrow-button>
      </div>
    </div>
  </div>
</div>
